export { ArtistDetails } from './ArtistDetails';
